// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to create access rules for all actions.
  </span>
</div>
<div class="alert">
  A new rule will be created only if one does not exist for the action/role.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Role:</td>
      <td>
        <select
          ng-model="\$ctrl.command.roleId"
          ng-options="role.id as role.name | prettyEnum for role in \$ctrl.roles | orderBy:'name'"
          required>
        </select>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/create-access-rules/create-access-rules.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;